import request from "../base/request";
import {applicationName} from "../utils";

let host = "/cm-sites-" + applicationName() + '/';

const Apis = {
    getInterviewTaskCreateResult: host + 'reportResult/getInterviewTaskCreateResult',//创建任务
    getInterviewTaskAcceptResult: host + 'reportResult/getInterviewTaskAcceptResult',//接收任务
};

export const getInterviewTaskCreateResult = (body, callBack) => {  //创建任务
    request({url:Apis.getInterviewTaskCreateResult, body, callBack});
};
export const getInterviewTaskAcceptResult = (body, callBack) => {  //接收任务
    request({url:Apis.getInterviewTaskAcceptResult, body, callBack});
};